import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const serviceContactModule = {
  namespaced: true,
  state: {
    serviceContactData: [],
    serviceContact: {}
  },
  getters: {
    getServiceContactData: (state) => state.serviceContactData,
    getServiceContact: (state) => state.serviceContact
  },
  mutations: {
    SET_SERVICE_CONTACT_DATA(state, payload) {
      state.serviceContactData = payload
    },
    SET_SERVICE_CONTACT(state, payload) {
      console.log(payload)
      state.serviceContact = payload
    }
  },
  actions: {
    async GET_SERVICE_CONTACT_DATA({ commit }, payload) {
      const { communityId } = payload
      try {
        const res = await baseFetch(
          API.getServiceContactList.url(communityId),
          API.getServiceContactList.method
        )

        if (!res.isError && res.data) {
          commit('SET_SERVICE_CONTACT_DATA', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async GET_SERVICE_CONTACT({ commit }, payload) {
      try {
        const res = await baseFetch(
          API.getServiceContact.url(payload),
          API.getServiceContact.method
        )

        if (!res.isError && res.data) {
          commit('SET_SERVICE_CONTACT', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async ADD_SERVICE_CONTACT(_, payload) {
      try {
        const res = await baseFetch(
          API.addServiceContact.url,
          API.addServiceContact.method,
          payload
        )

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async EDIT_SERVICE_CONTACT(_, payload) {
      try {
        const { serviceContactId, params } = payload
        const res = await baseFetch(
          API.editServiceContact.url(serviceContactId),
          API.editServiceContact.method,
          params
        )

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async DELETE_SERVICE_CONTACT(_, payload) {
      try {
        const res = await baseFetch(
          API.deleteServiceContact.url(payload),
          API.deleteServiceContact.method
        )

        console.log(res)

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async PIN_TOP(_, payload) {
      try {
        const res = await baseFetch(
          API.pinServiceContact.url(payload),
          API.pinServiceContact.method
        )

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async CANCEL_PIN_TOP(_, payload) {
      try {
        const res = await baseFetch(
          API.cancelPinServiceContact.url(payload),
          API.cancelPinServiceContact.method
        )

        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  }
}

export default serviceContactModule
